import { render, staticRenderFns } from "./organisation_set_up.vue?vue&type=template&id=30479abe"
import script from "./organisation_set_up.vue?vue&type=script&lang=js"
export * from "./organisation_set_up.vue?vue&type=script&lang=js"
import style0 from "./organisation_set_up.vue?vue&type=style&index=0&id=30479abe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports